export enum Product {
  SPOT = 'SPOT',
  FORWARD = 'FORWARD',
  SWAP = 'SWAP',
  SWAP_AFTER = 'SWAP_AFTER', SWAP_BEFORE = 'SWAP_BEFORE',
  HRR_AFTER = 'HRR_AFTER', HRR_BEFORE = 'HRR_BEFORE',
  SWAP_EXT = 'SWAP_EXT', SWAP_ET = 'SWAP_ET',
  HR_EXT = 'HR_EXT', HR_ET = 'HR_ET',
  MR_EXT = 'MR_EXT', MR_ET = 'MR_ET',
  DRAWDOWN = 'DRAWDOWN',
  WINDOW_FORWARD = 'WINDOW_FORWARD',
  TAKE_PROFIT = 'TAKE_PROFIT',
  STOP_LOSS = 'STOP_LOSS'
}

export const EarlyTakeUps = [Product.SWAP_ET, Product.MR_ET, Product.HR_ET];
export const Extensions = [Product.SWAP_EXT, Product.MR_EXT, Product.HR_EXT];

export function getRollableProducts(): Product[] {
  return [
    Product.SPOT,
    Product.SWAP,
    Product.FORWARD,
    Product.SWAP_EXT,
    Product.SWAP_ET,
    Product.HR_EXT,
    Product.HR_ET,
    Product.MR_EXT,
    Product.MR_ET,
    Product.WINDOW_FORWARD
  ];
}
